import { TNotification } from '@/types/Notification.types';
import { getNotifications } from '@/services/api/requests/notifications';
import queryKeys from '@/constants/queryKeys';
import { useInfinitePagination } from '../useInfinitePagination';
import { useAppStore } from '@/store/useAppStore';

const useGetInfiniteNotifications = ({ enabled }: { enabled: boolean }) => {
  const { user } = useAppStore();

  return useInfinitePagination<TNotification[]>({
    query: getNotifications,
    queryKey: [queryKeys.notifications.infinite, user?.email ?? ''],
    enabled,
  });
};

export default useGetInfiniteNotifications;
